import { useMutation } from '@tanstack/react-query';
import { registerToReferralProgram } from '../../../../../services/loyalty';

export default function useRegisterToReferralProgram() {
  return useMutation({
    mutationFn: (userId: string) => registerToReferralProgram(userId),
  });
}
